import { render, staticRenderFns } from "./ByCustomerAndCategory.vue?vue&type=template&id=110afab5&scoped=true&"
import script from "./ByCustomerAndCategory.vue?vue&type=script&lang=js&"
export * from "./ByCustomerAndCategory.vue?vue&type=script&lang=js&"
import style0 from "./ByCustomerAndCategory.vue?vue&type=style&index=0&id=110afab5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110afab5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VCard,VCardText,VChip,VProgressLinear})
